<template>
  <b-container class="transaction">
    <div class="st_title-regular-big text-center pt-4">
      請選擇你要下單的證券商
    </div>
    <b-row v-if="securitiesFirms && securitiesFirms.length" class="px-3 mt-3 pt-3">
      <b-col
        cols="4"
        class="transaction__margin px-1 d-flex flex-column cursor-pointer"
        @click.prevent="goTransaction(securitiesFirm.identity, true)"
        v-for="securitiesFirm in securitiesFirms"
        :key="securitiesFirm.identity">
        <div
          class="transaction__block pb-3 h-100"
          :class="{'transaction__block--default':securitiesFirm.transactionLink && securitiesFirm.transactionLink.isDefault}">
          <p class="transaction__default mb-0 pt-1 pl-2">
            <span v-if="securitiesFirm.transactionLink && securitiesFirm.transactionLink.isDefault">
              預設
            </span>
          </p>
          <b-img class="transaction__img d-block mx-auto mb-3" :src="securitiesFirm.icon" fluid />
          <p class="st_main-regular-small text-center mb-0">
            {{ securitiesFirm.name }}
          </p>
        </div>
      </b-col>
    </b-row>
    <b-row class="pb-3 pt-lg-3 px-lg-4" v-else-if="securitiesFirms">
      <b-col class="text-center" cols="12">
        目前還沒有任何券商喔
      </b-col>
    </b-row>
    <b-row class="justify-content-center m-3" v-else>
      <i class="fa fa-spinner fa-spin st_none-none-biggest-nlh" />
    </b-row>
    <div class="text-center mt-5 pt-4">
      <md-checkbox
        class="st-checkbox st_title-regular-base"
        v-model="setDefault">
        記住此次交易為預設券商
      </md-checkbox>
    </div>
    <TransactionModal
      v-if="selectSecuritiesFirm" :securitiesFirm="selectSecuritiesFirm"
      noCloseOnBackdrop :transactionType="transactionType" />
  </b-container>
</template>

<script>
  import { mapActions } from 'vuex'
  import TransactionModal from '~/components/modal/TransactionModal'

  export default {
    layout:     'fullpage',
    components: {
      TransactionModal,
    },
    data () {
      return {
        securitiesFirms:      null,
        selectSecuritiesFirm: null,
        transactionType:      '下單',
        setDefault:           true,
        transactionLink:      '',
      }
    },
    methods: {
      ...mapActions('api/securitiesFirm', ['getSecuritiesFirms', 'switchDefaultSecuritiesFirm', 'getSecuritiesFirmTransactionLink']),
      loadSecuritiesFirm () {
        this.securitiesFirms = null
        const option = {
          kind:   'TransactionLink',
          hidden: false,
          online: 'now',
          fields: ['identity', 'kind', 'icon', 'name', 'pathName', 'transactionURL.skipIntro', 'transactionURL.app'],
        }
        if (this.$userCheck.isAdmin()) {
          option.hidden = null
          delete option.online
        }
        this.getSecuritiesFirms(option)
          .then(data => {
            if (data && !data.error) {
              this.securitiesFirms = data.data
              if (data.data.length === 1) {
                this.goTransaction(data.data[0].identity, true)
              } else if (this.$route.query.securitiesFirm) {
                switch (this.$route.query.securitiesFirm) {
                  case 'default':
                    const defaultSecuritiesFirm = (data.data.find(securitiesFirm => !!(
                      securitiesFirm.transactionLink && securitiesFirm.transactionLink.isDefault
                    )) || {}).identity || null
                    if (defaultSecuritiesFirm) {
                      this.goTransaction(defaultSecuritiesFirm)
                    }
                    break
                  default:
                    const pathSecuritiesFirm = (data.data.find(securitiesFirm => securitiesFirm.pathName === this.$route.query.securitiesFirm) || {}).identity || null
                    if (pathSecuritiesFirm) {
                      this.goTransaction(pathSecuritiesFirm)
                    }
                    break
                }
              }
            } else {
              this.securitiesFirms = []
            }
          })
      },
      async goTransaction (securitiesFirm, userSelect = false) {
        this.selectSecuritiesFirm = this.securitiesFirms.find(securitiesFirmData => securitiesFirmData.identity === securitiesFirm) || null
        if (
          this.$route.query.skipIntro
          || (
            !this.$route.query.skipIntro
            && (
              (
                this.selectSecuritiesFirm.transactionLink
                && this.selectSecuritiesFirm.transactionLink.activate
              )
              || (
                this.selectSecuritiesFirm.transactionURL
                && this.selectSecuritiesFirm.transactionURL.skipIntro
              )
            )
          )
        ) {
          await this.$nextTick()
          if (this.selectSecuritiesFirm) {
            await this.$root.$emit('bv::show::modal', 'goTransactionModal')
          } else {
            return
          }
          const option = {
            securitiesFirm: securitiesFirm,
          }
          if (this.$route.query.action) {
            option.action = this.$route.query.action
          }
          if (this.$route.query.target) {
            option.target = this.$route.query.target
          }
          if (this.$route.query.setDefault || (userSelect && this.setDefault)) {
            option.isDefault = true
          }
          await this.getSecuritiesFirmTransactionLink(option).then(data => {
            if (!data.error) {
              this.transactionLink = data.url || ''
            }
          })
        } else if (this.selectSecuritiesFirm.pathName) {
          window.location.href = `/partner/${this.selectSecuritiesFirm.pathName}?securitiesFirm=${this.selectSecuritiesFirm.pathName}&skipIntro=true${
            this.$route.query.action ? `&action=${this.$route.query.action}` : ''
          }${this.$route.query.target ? `&target=${this.$route.query.target}` : ''
          }${(this.$route.query.setDefault || (userSelect && this.setDefault)) ? '&setDefault=true' : ''}`
        }

        if (this.transactionLink !== '' && this.$userCheck.isLogin()) {
          if (Object.values(this.$route.query).length) this.$router.replace({ name: this.$route.name }, () => {}, () => {})
          await new Promise(resolve => setTimeout(resolve, 150))
          window.location.href = this.transactionLink
        }
      },
    },
    mounted () {
      this.loadSecuritiesFirm()
    },
  }
</script>

<style lang="scss" scoped>
  .transaction {
    background: $st_color_white;
    height: 100vh;

    &__img {
      width: 45px;
      height: 45px;
    }

    &__default {
      font-size: $st_font-size-smaller;
      color: $st_color_sub_light;
      letter-spacing: 0.69px;
      height: 18px;
    }

    &__block {
      background: rgba(240, 241, 243, 0.3);

      &--default {
        background-color: rgba(234, 185, 133, 0.1);
      }
    }

    &__margin {
      &:not(:nth-of-type(1)), &:not(:nth-of-type(2)), &:not(:nth-of-type(3)) {
        margin-top: 8px;
      }
    }
  }
</style>
